import {Alert} from 'src/design/atoms/Alert';

export interface AnonymousSubmissionTextProps {
  text?: string;
}
export const AnonymousSubmissionText: React.FC<
  AnonymousSubmissionTextProps
> = ({text}) => {
  return (
    <Alert title="Anonymous Submission" color="yellow" mb="md">
      {text ??
        'This form is configured to have anonymous submissions. Your name and other user information will not be visible after submission.'}
    </Alert>
  );
};
